export default "__VITE_ASSET__DoGgeSYu__"